import React, { useEffect, useMemo, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Col, Tooltip } from "antd";

import { roundNumber } from "../../../../modules/consignmentFunctions";

const defaultItems = [{ message: "--", data: {} }];

const CARD_CODE = "CARD";

const getPrice = (price, currency, intl) =>
  `${roundNumber(price)} ${intl.formatMessage(
    {
      id: "calculator.priceWithoutVat",
      defaultMessage: "{currency} bez DPH",
    },
    { currency: currency }
  )}`;

const parseItems = (items, intl) =>
  items
    ? items.map((i) => ({
        message: `${intl.formatMessage({
          id: "calculator.price." + i.code,
          defaultMessage: i.name || i.code || "??",
        })} ➔ ${getPrice(i.price, i.currency, intl)}`,
        data: i,
      }))
    : defaultItems;

const CalculationTitle = ({
  price,
  items,
  detailed,
  isSlovakia,
  priceCurrency,
}) => {
  const intl = useIntl();

  const [parsedItems, setParsedItems] = useState(defaultItems);
  const [currency, setCurrency] = useState("CZK");
  useEffect(() => {
    priceCurrency
      ? setCurrency(priceCurrency)
      : items &&
        items.some((i) => i.currency) &&
        setCurrency(items.find((i) => i.currency).currency);
    setParsedItems(parseItems(items, intl));
  }, [intl, items, priceCurrency]);

  const cardItem = useMemo(
    () => parsedItems.find((i) => i.data.code === CARD_CODE),
    [parsedItems]
  );

  return price ? (
    detailed ? (
      <Tooltip
        title={intl.formatMessage(
          {
            id: "calculator.price.total",
            defaultMessage: "Celková cena je {price} {currency}",
          },
          {
            price: roundNumber(price),
            currency: intl.formatMessage(
              {
                id: "calculator.priceWithoutVat",
                defaultMessage: "{currency} bez DPH",
              },
              { currency }
            ),
          }
        )}
      >
        {parsedItems
          .filter((i) => isSlovakia || i.data.code !== CARD_CODE)
          .map((i, idx) => (
            <Row key={idx}>
              <Col>{i.message}</Col>
              {i.data && i.data.code === "COD" && !isSlovakia && cardItem ? (
                <p className="font-13">
                  <FormattedMessage
                    id="calculator.price.card"
                    defaultMessage="(v případě platby kartou se neúčtuje doběrečné, ale kartovné ve výši {price})"
                    values={{
                      price: getPrice(
                        cardItem.data.price,
                        cardItem.data.currency,
                        intl
                      ),
                    }}
                  />
                </p>
              ) : (
                <></>
              )}
            </Row>
          ))}
      </Tooltip>
    ) : (
      <Tooltip
        overlayStyle={{ maxWidth: "500px" }}
        title={parsedItems.map((i, idx) => (
          <div key={idx}>{i.message}</div>
        ))}
      >
        {`${roundNumber(price)} ${intl.formatMessage(
          {
            id: "calculator.priceWithoutVat",
            defaultMessage: "{currency} bez DPH",
          },
          { currency }
        )}`}
      </Tooltip>
    )
  ) : (
    <Tooltip
      title={intl.formatMessage({
        id: "calculator.noPrice",
        defaultMessage: "cena není známa",
      })}
    >
      {price === 0 ? (
        <FormattedMessage
          id="calculator.price.unknown"
          defaultMessage="Pro zásilku s těmito parametry není definován ceník."
        />
      ) : (
        "--"
      )}
    </Tooltip>
  );
};

export default CalculationTitle;
